export default function is_touch_device() {
    return false; //!!('ontouchstart' in window || navigator.maxTouchPoints);  
}
